<template>
  <div
    class="tab-content local-file-uploader-modal__content-wrapper"
    :class="{'is-uploading-converting': !staticState, 'is-tab-upload-image': isTabUploadImage}"
  >
    <label for="upload-file" class="local-file-uploader-modal__content">
      <div v-if="staticState" class="local-file-uploader-modal__content-text">
        <aha-icon
          :name="icon.name"
          :width="icon.width"
          :height="icon.height"
          :viewBox="icon.viewBox"
          class="tab-content__icon"
        />
        <div class="pt-4 pb-2 font-bold">
          <span class="local-file-uploader__text-drag-drop">
            {{ $i18nPresenter.t("Drag and drop your files here or") }}
          </span>
          <span class="tab-content__browse-text">{{ $i18nPresenter.t("browse") }}</span>
        </div>
        <p class="text-sm">{{ instructionText }}</p>
        <div
          class="pt-4 text-red-100 error-text text-sm"
          v-if="uploadError"
          v-html="uploadError"
        />
      </div>

      <div class="text-center" v-if="uploadingState || convertingState">
        <aha-icon
          :name="icon.name"
          :width="icon.width"
          :height="icon.height"
          :viewBox="icon.viewBox"
          class="tab-content__icon"
        />
        <p class="font-bold pt-4" v-if="uploadingState">{{ $i18nPresenter.t("Uploading...") }}</p>
        <p class="font-bold pt-4" v-if="convertingState">{{ $i18nPresenter.t("Converting...") }}</p>
        <div class="py-2">
          <aha-spinner
            variant="dark"
          />
        </div>
        <div class="pt-2 text-sm">
          {{ $i18nPresenter.t("It might take a while to finish.") }}
        </div>
        <div class="pt-2 text-sm">
          <span class="pr-1">{{ $i18nPresenter.t("To continue uploading in the background, please") }}</span>
          <span
            class="text-primary-90 font-bold hover:text-primary-100 cursor-pointer"
            @click="hide()"
          >{{ $i18nPresenter.t("close this pop-up") }}<span>.</span>
          </span></div>
      </div>

      <b-form-file
        v-model="file"
        :state="Boolean(file)"
        choose-label="Attachment2"
        :accept="fileFormat"
        id="upload-file"
        v-if="staticState"
        :drop-placeholder="dropPlaceholder"
        :file-name-formatter="uploadFile"
        @mouseup.stop
      />
    </label>
  </div>
</template>

<script>
import EventBus from '@/eventBus'
import utils from '@/util'

// uploader
import BootstrapUploader from '@/utils/uploader/BootstrapUploader'
import AhaSlidesUploader from '@/utils/uploader/AhaSlidesUploader'

export default {
  props: {
    staticState: {
      type: Boolean,
      default: false,
    },
    uploadingState: {
      type: Boolean,
      default: false,
    },
    convertingState: {
      type: Boolean,
      default: false,
    },
    uploadError: {
      type: String,
      default: null,
    },
    featureName: {
      type: String,
      default: null,
    },
    needGenerateQuiz: {
      type: Boolean,
      default: false,
    },
    instructionText: {
      type: String,
      default: null,
    },
    customPropsForTracking: {
      type: Object,
      default: () => ({}),
    },
    fileFormat: {
      type: String,
      default: '.ppt, .pptx, .pdf',
    },
    icon: {
      type: Object,
      default: () => ({
        name: 'import-no-background',
        width: '68',
        height: '68',
        viewBox: '0 0 69 69',
      }),
    },
    dropPlaceholder: {
      type: String,
      default: 'drop image',
    },

    // UPLOAD IMAGE
    isTabUploadImage: {
      type: Boolean,
      default: false,
    },
    signedCFUrlExpiryDate: {
      type: Number,
      default: null,
    },
    featureToUploadImage: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      file: null,
      isUploadFileCalled: false,
    }
  },
  mounted() {
    EventBus.$on('LocalFileUploader: uploadFile', (payload) => {
      this.uploadFile(payload)
    })
  },
  destroyed() {
    EventBus.$off('LocalFileUploader: uploadFile')
  },
  methods: {
    async uploadFile(files) {
      if (this.isUploadFileCalled) return // prevent doc-to-slide multiple calls
      this.isUploadFileCalled = true
      const bootstrapUploader = new BootstrapUploader(
        // local variables - GENERATE FROM DOC
        this.needGenerateQuiz,

        // local variables - IMPORT PPT PDF
        this.customPropsForTracking,

        // local variables - IMPORT SPREADSHEET
        this.$route.name,

        // local variables - UPLOAD IMAGE
        this.signedCFUrlExpiryDate,
        this.featureToUploadImage,
      )
      const ahaSlidesUploader = new AhaSlidesUploader(bootstrapUploader, this.featureName)
      ahaSlidesUploader.upload(files)
      await utils.sleep(1000)
      this.isUploadFileCalled = false
    },
  },
}
</script>

<style lang="scss" scoped>
.local-file-uploader-modal__content-wrapper {
  @apply border-2 border-dashed hover:border-primary-90 px-4 border-secondary-20;
  @apply bg-primary-50 hover:bg-primary-60 rounded py-12;
  @apply relative text-center text-xl cursor-pointer;
  &:hover {
    .tab-content__icon {
      @apply text-primary-90;
    }
    .local-file-uploader-modal__content, .local-file-uploader-modal__content-text {
      @apply bg-primary-60;
    }
  }
  &.is-uploading-converting {
    @apply py-4;
  }
  .tab-content__browse-text {
    @apply text-primary-90 hover:text-primary-100 cursor-pointer relative;
    z-index: 2;
  }
  .local-file-uploader-modal__content {
    @apply text-center;
  }
}
.custom-file {
  @apply absolute inset-0 overflow-hidden opacity-0 cursor-pointer z-1;
  & ::v-deep .custom-file-input {
    @apply w-full h-full;
  }
}
.local-file-uploader__text-drag-drop {
  @apply pb-1;
}
</style>
